import { Component, inject } from '@angular/core';
import { MasterService } from '../../core/services/master.service';
import { eClick } from '../../core/services/entities';
import { HaylieService } from '../../core/services/haylie.service';

@Component({
  selector: 'app-sidebar',
  imports: [],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  standalone: true
})
export class SidebarComponent {

  private _svc_master = inject(MasterService);
  private _svc_haylie = inject(HaylieService);

  trg_sidebar():void {
    this._svc_master.trg_sidedar("sidebar_close");
  }
  navigate(p_destiny:string):void {

    this._svc_master.navigate(p_destiny);
    this._svc_master.trg_sidedar("sidebar_close");
     
  }

  /*** *tmp **/
  goHaylie(p_param:string): void{

    switch (p_param) {
      case "regclick":
        var click = new eClick();
        this._svc_haylie.send_click(click); 
        break;
    }

  }

}
